import axios from 'axios';
import * as qs from 'qs';
import resolvePath from 'utils/resolvePath';
// Action
const FORWARD = 'blocks/forward';
const CLEAR = 'blocks/clear';
const GET_BLOCKS_REQUEST = 'blocks/getBlocksRequest';
const GET_BLOCKS_SUCCESS = 'blocks/getBlocksSuccess';
const GET_BLOCKS_FAILURE = 'blocks/getBlocksFailure';
// 仮。実際はGET_BLOCKS_ID_REQUEST, SUCCESS, FAILUREのセットで管理するはず。
const GET_BLOCKS_ID = 'favorites/getBlocksId';
const CLEAR_BLOCKS_ID = 'favorites/clearBlocksId';
const POST_BLOCKS_REQUEST = 'blocks/postBlocksRequest';
const POST_BLOCKS_SUCCESS = 'blocks/postBlocksSuccess';
const POST_BLOCKS_FAILURE = 'blocks/postBlocksFailure';
const DELETE_BLOCKS_REQUEST = 'blocks/deleteBlocksRequest';
const DELETE_BLOCKS_SUCCESS = 'blocks/deleteBlocksSuccess';
const DELETE_BLOCKS_FAILURE = 'blocks/deleteBlocksFailure';
// Action Creator
export const forward = () => {
    return {
        type: FORWARD,
    };
};
export const clear = () => {
    return {
        type: CLEAR,
    };
};
export const getBlocksRequest = () => {
    return {
        type: GET_BLOCKS_REQUEST,
    };
};
export const getBlocksSuccess = (response) => {
    return {
        payload: {
            response,
        },
        type: GET_BLOCKS_SUCCESS,
    };
};
export const getBlocksFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_BLOCKS_FAILURE,
    };
};
export const getBlocks = (authToken, parameters) => (dispatch) => {
    dispatch(getBlocksRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    return axios
        .get(`${resolvePath.api('blocks')}?${qs.stringify(parameters)}`, config)
        .then((response) => dispatch(getBlocksSuccess(response.data)))
        .catch((error) => {
        dispatch(getBlocksFailure(error));
        throw error;
    });
};
export const getBlocksId = (blockedUser) => {
    return {
        payload: {
            blockedUser,
        },
        type: GET_BLOCKS_ID,
    };
};
export const clearBlocksId = () => {
    return {
        type: CLEAR_BLOCKS_ID,
    };
};
export const postBlocksRequest = () => {
    return {
        type: POST_BLOCKS_REQUEST,
    };
};
export const postBlocksSuccess = (blockedUser) => {
    return {
        payload: {
            blockedUser,
        },
        type: POST_BLOCKS_SUCCESS,
    };
};
export const postBlocksFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: POST_BLOCKS_FAILURE,
    };
};
export const postBlocks = (authToken, parameters) => (dispatch) => {
    dispatch(postBlocksRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    return axios
        .post(resolvePath.api('blocks'), parameters, config)
        .then((response) => dispatch(postBlocksSuccess(response.data)))
        .catch((error) => {
        dispatch(postBlocksFailure(error));
        throw error;
    });
};
export const deleteBlocksRequest = () => {
    return {
        type: DELETE_BLOCKS_REQUEST,
    };
};
export const deleteBlocksSuccess = (unblockedUser) => {
    return {
        payload: {
            unblockedUser,
        },
        type: DELETE_BLOCKS_SUCCESS,
    };
};
export const deleteBlocksFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: DELETE_BLOCKS_FAILURE,
    };
};
export const deleteBlocks = (authToken, parameters) => (dispatch) => {
    dispatch(deleteBlocksRequest());
    const config = {
        data: parameters,
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    return axios
        .delete(resolvePath.api('blocks'), config)
        .then((response) => dispatch(deleteBlocksSuccess(response.data)))
        .catch((error) => {
        dispatch(deleteBlocksFailure(error));
        throw error;
    });
};
const initialState = {
    blockedUser: null,
    blocks: [],
    error: null,
    isFetching: false,
    meta: {
        current_page: 0,
        next_page: null,
        per_page: 0,
        previous_page: 0,
        total_entries: 0,
        total_pages: 0,
    },
    page: 1,
    unblockedUser: null,
};
export default (state = initialState, action) => {
    switch (action.type) {
        case FORWARD: {
            return Object.assign(Object.assign({}, state), { page: state.page + 1 });
        }
        case CLEAR: {
            return Object.assign(Object.assign({}, state), { blocks: [], page: 1 });
        }
        case GET_BLOCKS_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case GET_BLOCKS_SUCCESS: {
            return Object.assign(Object.assign({}, state), { blocks: state.blocks.concat(action.payload.response.data), isFetching: false, meta: Object.assign({}, action.payload.response.meta) });
        }
        case GET_BLOCKS_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case GET_BLOCKS_ID: {
            return Object.assign(Object.assign({}, state), { blockedUser: Object.assign({}, action.payload.blockedUser), isFetching: false });
        }
        case CLEAR_BLOCKS_ID: {
            return Object.assign(Object.assign({}, state), { blockedUser: null, isFetching: false });
        }
        case POST_BLOCKS_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case POST_BLOCKS_SUCCESS: {
            return Object.assign(Object.assign({}, state), { blockedUser: Object.assign({}, action.payload.blockedUser), isFetching: false });
        }
        case POST_BLOCKS_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case DELETE_BLOCKS_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case DELETE_BLOCKS_SUCCESS: {
            return Object.assign(Object.assign({}, state), { isFetching: false, unblockedUser: Object.assign({}, action.payload.unblockedUser) });
        }
        case DELETE_BLOCKS_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        default: {
            return state;
        }
    }
};
